module.exports = __webpack_public_path__ + "static/media/220216_sejong_projectguide.89ab6e7b.jpg";